import { memo } from "react";
import { Grid2, Typography } from "@mui/material";
import { useQuery } from "@apollo/client";
import { Document, Query } from "@/app/graphql/codegen";
import { FETCH_DOCUMENTS_LIST } from "@documents/graphql/queries/fetchDocumentsList";
import { LexiconList } from "@documents/components/lexicon/LexiconList";
import LexiconDetails from "@documents/components/lexicon/LexiconDetails";
import LexiconDocumentFilter from "@documents/components/lexicon/LexiconDocumentFilter";
import { useViewSlice } from "@store/slices/view";
import { availableViewportHeight } from "@core/layout/AppLayout";

const LexiconPage = memo(() => {
    useQuery<Pick<Query, "officialDocuments">, Document[]>(FETCH_DOCUMENTS_LIST);
    const { showExtendedView } = useViewSlice();
    const filterButtonsHeight = 66;
    const spacingHeight = 24;
    const availableListHeight = `calc(${availableViewportHeight} - ${filterButtonsHeight}px - ${spacingHeight}px)`;
    const availableDetailsHeight = `calc(${availableViewportHeight} - ${filterButtonsHeight}px + 8px)`;

    return (
        <Grid2 container columnSpacing={2} rowSpacing={0} sx={{ border: `${showExtendedView ? 1 : 0}px solid blue` }} overflow={"hidden"} height={availableViewportHeight}>
            {/* Linke Seite mit Chatliste */}

            <Grid2 size={12} mb={1}>
                <Typography variant="h4" fontWeight="medium">
                    Gesetzeslexikon
                </Typography>
            </Grid2>

            <Grid2 container size={{ xs: 12, sm: 4 }}>
                <LexiconDocumentFilter />
                <Grid2
                    container
                    sx={{
                        border: `${showExtendedView ? 1 : 0}px solid green`,
                        "&::-webkit-scrollbar": { display: "none" },
                        scrollbarWidth: "none",
                        // "& .MuiTreeItem-group": {
                        //     marginLeft: 0,
                        // },
                    }}
                    overflow={"auto"}
                    height={availableListHeight}
                >
                    <LexiconList />
                </Grid2>
            </Grid2>

            {/* Rechte Seite mit Chatdetails */}
            <Grid2 size={{ xs: 12, sm: "grow" }} sx={{ border: `${showExtendedView ? 1 : 0}px solid red` }} height={availableDetailsHeight}>
                <LexiconDetails />
            </Grid2>
        </Grid2>
    );
});

export default LexiconPage;
